import {
  ASK_OUTCOMES,
  OP_DONE_FALLBACK_LABEL,
  OP_DONE_LABELS,
  OP_FAILED_FALLBACK_LABEL,
  OP_FAILED_LABELS,
  OP_RUNNING_FALLBACK_LABEL,
  OP_RUNNING_LABELS
} from '../../constants/aiAnalytics';

import { resumedOpTitle } from './aiSelectors';

export function chartOpKey(chartId) {
  return `chart:${chartId}`;
}

export function messageOpKey(messageId) {
  return `message:${messageId}`;
}

export function operationKey(operation) {
  return operation.chartId ? chartOpKey(operation.chartId) : messageOpKey(operation.messageId);
}

export function finishedResumedOps(pendingOps, activeKeys) {
  return Object.values(pendingOps).filter(op => op.resumed && !activeKeys.has(op.key));
}

export function resumedOpDescriptor(operation, state) {
  return {
    key: operationKey(operation),
    kind: operation.kind,
    label: OP_RUNNING_LABELS[operation.kind] || OP_RUNNING_FALLBACK_LABEL,
    threadId: operation.threadId,
    chartId: operation.chartId,
    messageId: operation.messageId,
    title: resumedOpTitle(state, operation),
    resumed: true
  };
}

export function opOutcomeLabel(outcome, kind) {
  if (outcome === ASK_OUTCOMES.FINISHED) {
    return OP_DONE_LABELS[kind] || OP_DONE_FALLBACK_LABEL;
  }
  return OP_FAILED_LABELS[kind] || OP_FAILED_FALLBACK_LABEL;
}

let watchingResumedOps = false;

export function acquireResumedOpsWatch() {
  if (watchingResumedOps) {
    return false;
  }
  watchingResumedOps = true;
  return true;
}

export function releaseResumedOpsWatch() {
  watchingResumedOps = false;
}

export function isWatchingResumedOps() {
  return watchingResumedOps;
}

export function resetResumedOpsWatchForTests() {
  watchingResumedOps = false;
}
